<template>
  <div class="date-time-range-input">
    <div class="form-group" :class="{ 'has-feedback' : isDirty }">
      <label class="col-sm-4 control-label" for="control-label">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div class="col-sm-8">
        <template v-for="day in days">
          <label class="checkbox-inline" :for="options.name + '[' + day + ']'">
            <input type="checkbox"
              :id="options.name + '[' + day + ']'"
              :checked="value[day]"
              @change="checkValue($event.target)"
              :name="options.name + '[' + day + ']'" />
              {{ uppercase(day) }}
          </label>
        </template>
        <br/><br/>
        <p>
          <label class="checkbox-inline">
            <input type="checkbox" @change="checkAll()" v-model="allChecked" />
              <strong>{{ allChecked ? 'Un-check' : 'Check' }} All</strong>
          </label>
        </p>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
export default {
  name: 'DayRangeInput',
  props: {
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    },
    value: {
      default () {
        return {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false
        }
      }
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      return this.options.label + ' is required'
    }
  },
  data () {
    return {
      allChecked: false,
      isValid: false,
      isDirty: false,
      days: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ]
    }
  },
  methods: {
    checkAll () {
      let value = this.value
      for (let day in value) {
        value[day] = this.allChecked
      }
      this.validate(value)
    },
    uppercase (str) {
      return str[0].toUpperCase() + str.substr(1, str.length)
    },
    checkValue (val) {
      let value = this.value
      for (let day in value) {
        if (val.name.includes(day)) {
          value[day] = val.checked
        }
      }
      this.validate(value)
    },
    validate (val = this.value) {
      this.$emit('input', val)
      this.isDirty = true
      let checked = false
      for (let day in val) {
        if (val[day]) checked = true
      }
      if (this.options.required && !checked) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DayRangeInput.vue